export function formatCategoryName(category) {
  if (!category) return '';
  const categoryMap = {
    restaurant: 'Restaurant',
    cafe: 'Cafe',
    park: 'Park',
    activity: 'Activity',
    event: 'Event',
    hidden_gem: 'Hidden Gem',
    food: 'Food',
    outdoors: 'Outdoors',
    arts: 'Arts',
    nightlife: 'Nightlife',
    family: 'Family',
    shopping: 'Shopping',
    sports: 'Sports',
    nature: 'Nature',
    history: 'History',
    music: 'Music',
  };
  return categoryMap[String(category).toLowerCase()] || String(category).split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

export const INITIAL_PLACE_FORM = {
  name: '',
  contributorId: '',
  description: '',
  category: '',
  categories: [],
  priceRange: 'mid',
  vibeTags: [],
  tags: [],
  address: '',
  googleMapsLink: '',
  openingHours: {
    monday: { open: '', close: '' },
    tuesday: { open: '', close: '' },
    wednesday: { open: '', close: '' },
    thursday: { open: '', close: '' },
    friday: { open: '', close: '' },
    saturday: { open: '', close: '' },
    sunday: { open: '', close: '' },
  },
  comment: '',
  contactInfo: { phoneNumber: '', email: '' },
  primaryTag: '',
  famousTags: [],
  isFeatured: false,
  isTrending: false,
  offers: [],
  ledgerMinLe: '',
  ledgerBalanceLe: null,
  commissionPercent: '',
  cashbackPercent: '',
  pointsCapPercent: '',
  marketingFeeLe: '',
  marketingFeeMinBillLe: '',
  marketingFeeMaxLe: '',
};

export const INITIAL_CATEGORY_FORM = {
  name: '',
  icon: '',
  description: '',
  color: '#2196F3',
  sortOrder: 0,
};

export const INITIAL_TAG_FORM = {
  name: '',
  slug: '',
  description: '',
  sortOrder: 0,
  tagType: 'vibe', // 'vibe' = Primary Tag & Vibe Tags pool; 'famous' = Famous Tag only (e.g. Hidden Gem, Trending)
};

export const INITIAL_BANNER_FORM = {
  title: '',
  description: '',
  imageUrl: '',
  featureType: 'place',
  targetType: 'place',
  targetId: '',
  position: 'top',
  order: 0,
  startDate: new Date().toISOString().split('T')[0],
  endDate: '',
  isActive: true,
  isFeaturedPlace: false,
};

export const INITIAL_FEATURED_ITEM_FORM = {
  title: '',
  description: '',
  imageUrl: '',
  targetType: 'place',
  targetId: '',
  startDate: new Date().toISOString().split('T')[0],
  endDate: '',
  isActive: true,
};
